import { createRequestInstance } from 'services'

const CONTENT_URL = import.meta.env.VITE_CONTENT_URL || ''

const request = createRequestInstance({
  baseURL: CONTENT_URL,
})

export async function fetchPath<T>(path: string) {
  const response = await request.get<{
    tiles: [
      {
        acf: T
      },
    ]
  }>('', {
    params: { full_path: path },
  })

  return response.data.tiles[0].acf
}
